export const insertModuleInContent = ({ component, parentSelector = '.mw-parser-output', }) => {
    const parentElement = document.querySelector(parentSelector);
    if (!parentElement) {
        console.error(`Cannot find element with selector "${parentSelector}"`);
        return null;
    }
    const paragraphs = Array.from(parentElement.querySelectorAll(`${parentSelector} > p`));
    // If the article has only one paragraph, show nothing
    if (paragraphs.length <= 1) {
        return null;
    }
    const h2headers = Array.from(parentElement.querySelectorAll(`${parentSelector} > h2`));
    const h3headers = Array.from(parentElement.querySelectorAll(`${parentSelector} > h3`));
    if (h2headers.length === 0 && h3headers.length === 0) {
        console.error(`No headers found in the article`);
        return null;
    }
    const targetHeader = {
        type: null,
        index: null,
    };
    let targetHeaderElement = null;
    // If we have a set of H3s (2+) within a section (which starts h2), inject in-between h3.
    if (h3headers.length >= 2) {
        targetHeaderElement = h3headers[1];
        targetHeader.type = 'h3';
        targetHeader.index = 1;
    }
    // If we've no H3s, and 3+ H2, we place the module before the third H2
    if (!targetHeaderElement && h2headers.length >= 3) {
        targetHeaderElement = h2headers[2];
        targetHeader.type = 'h2';
        targetHeader.index = 2;
    }
    if (targetHeader.type && targetHeader.index) {
        parentElement.insertBefore(component, targetHeaderElement);
        return targetHeader;
    }
    return null;
};
